import { Box } from "@mui/material";
import { useEffect, FC } from "react";
import { CommonStyle } from "Components";
import PatientThreshold from "Components/PatientThreshold";
import { useParams } from "react-router-dom";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { RouteUrls } from "Constant/RouteUrls";
import CommonFormatter from "Utils/Common.Formatter";

const PatientThresholdAlerts: FC = () => {
  const { patientId } = useParams();
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "patient-threshold",
      label: "Patient Thresholds",
      path: `/${RouteUrls.hs}/${RouteUrls.patient}` +
        `/${patientInfo.id}/${RouteUrls.thresholds}`,
      level: 3,
      link: RouteUrls.thresholds,
      navType: "patient",
    });
  }, []);

  return (
    <Box my={1} sx={{ ...CommonStyle.sxWhiteCard }} width="100%">
      <PatientThreshold
        showSaveButton={true}
        isSavedCounter={null}
        patientId={patientId}
      />
    </Box>
  );
};
export default PatientThresholdAlerts;
